var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInteraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_45077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.33333H11.1667C10.064 7.33333 9.16667 8.23067 9.16667 9.33333V14C9.16667 15.1027 10.064 16 11.1667 16H14.5C15.6027 16 16.5 15.1027 16.5 14V9.33333C16.5 8.23067 15.6027 7.33333 14.5 7.33333ZM13.8333 13.3333H11.8333C11.4647 13.3333 11.1667 13.0347 11.1667 12.6667C11.1667 12.2987 11.4647 12 11.8333 12H13.8333C14.202 12 14.5 12.2987 14.5 12.6667C14.5 13.0347 14.202 13.3333 13.8333 13.3333ZM13.8333 10.6647H11.8333C11.4647 10.6647 11.1667 10.366 11.1667 9.998C11.1667 9.63 11.4647 9.33133 11.8333 9.33133H13.8333C14.202 9.33133 14.5 9.63 14.5 9.998C14.5 10.366 14.202 10.6647 13.8333 10.6647ZM2.5 4C2.5 1.794 4.294 0 6.5 0C8.706 0 10.5 1.794 10.5 4C10.5 6.206 8.706 8 6.5 8C4.294 8 2.5 6.206 2.5 4ZM8.51733 16H1.16667C0.795334 16 0.499334 15.6933 0.500001 15.322C0.506001 12.0187 3.19533 9.33333 6.5 9.33333C6.95867 9.33333 7.404 9.39 7.83333 9.488V14C7.83333 14.7533 8.094 15.4413 8.51733 16Z",
    fill: "#C8707E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_45077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteraction);
export default __webpack_public_path__ + "static/media/interaction.00cf87c9bfea02caa9b04ed29d5c3444.svg";
export { ForwardRef as ReactComponent };